
import { defineComponent } from 'vue';
import { beautifyText } from '../helpers/beautifyText';

export default defineComponent({
	name: 'BeautifyText',
	computed: {
		lines() {
			return beautifyText(this.text, true);
		}
	},
	methods: {
		nextLineType(index: number) {
			return this.lines[index + 1]?.type;
		},
		openInvisibleLink(to: string) {
			window.location.href = to;
		}
	},
	props: {
		text: { type: String, required: true },
		linkToApply: { type: String, default: '#' }
	}
});
